// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__VylQ4","innerContainer":"styles_innerContainer__YCvxQ","list":"styles_list__59lZy","skeleton":"styles_skeleton__gISrN","title":"styles_title__LyIvQ"};